import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataWithdrawalRejectionReasonReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

export const getStaticDataState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);

export const getWithdrawalRejectionReasonState = createSelector(
  getStaticDataState,
  state => state[fromStaticDataReducer.fromWithdrawalRejectionReasonReducer.withdrawalRejectionReasonFeatureKey]
);

export const getWithdrawalRejectionReasons = createSelector(
  getWithdrawalRejectionReasonState,
  staticDataWithdrawalRejectionReasonReducer.fromWithdrawalRejectionReasonReducer.getWithdrawalRejectionReasons
);

export const getWithdrawalRejectionReasonsLoading = createSelector(
  getWithdrawalRejectionReasonState,
  staticDataWithdrawalRejectionReasonReducer.fromWithdrawalRejectionReasonReducer.getWithdrawalRejectionReasonsLoading
);

export const getWithdrawalRejectionReasonsFailure = createSelector(
  getWithdrawalRejectionReasonState,
  staticDataWithdrawalRejectionReasonReducer.fromWithdrawalRejectionReasonReducer.getWithdrawalRejectionReasonsFailure
);
